import { AxiosInstance } from 'axios';
import UserService from './userService';

export default function useUser( axiosIns: AxiosInstance, userOverrideConfig: Object ) {
  const user = new UserService( axiosIns, userOverrideConfig )

  return {
    user,
  }
}